import QualificationList from 'components/QualificationList';
import { OrganizationRow } from 'components/tables/data/organization/types';

/**
 * Column for the organization qualifications.
 */
export default function QualificationsColumn({ data: { qualifications } }: { data: OrganizationRow }) {
  return <QualificationList qualifications={qualifications} limit={2} />;
}
